module.exports = __webpack_public_path__ + "img/standard_5000ml.4a53690c.png";